export enum AcquisitionNumberType {
    Own = 1,
    SuperiorOrganizationUnit = 2,
    SecondaryAcquisitionNumber = 3,
    ShortInsuranceOrganizationUnitId = 4,
    OwnDivided = 5
}

export const AcquisitionNumberTypes = [
    [AcquisitionNumberType.Own, 'Vlastní'],
    [AcquisitionNumberType.SuperiorOrganizationUnit, 'Nadřízená organizační jednotka'],
    [AcquisitionNumberType.SecondaryAcquisitionNumber, 'Sekundární ziskatelské číslo'],
    [AcquisitionNumberType.ShortInsuranceOrganizationUnitId, 'Denní POV'],
    [AcquisitionNumberType.OwnDivided, 'Vlastní rozdělené']
]

export const getAcquisitionNumberTypeName = (type?: AcquisitionNumberType) => {
    return AcquisitionNumberTypes.find(([key]) => key === type)?.[1] ?? undefined
}